export * from './FooterCommon';
export * from './FooterNewsletter';
export * from './FooterColumn';
export * from './FooterSocialLinks';
export * from './FooterCopyright';
export * from './FooterLegalLinks';
export * from './footerData';
export { default as Footer } from './Footer';
export * from './FooterMinimal';
